import { memo, useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import HookInput from "@/components/Elements/HookInput";
import {
  catchErrors,
  getObjKeysLength,
  putFormValidationFocus,
} from "@/util/functions";
import { LOGIN } from "../../constants/routs.constants";
import { authApi } from "@/api";
import { login } from "@/store/authSlice";
import { toast } from "react-toastify";

const Register = function () {
  const authError = useSelector(({ auth }) => auth.error);

  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
  } = useForm();

  const isErrorsLength = !!getObjKeysLength(errors);

  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      // put data in right form
      data.role = "labeler"; // we need to include "role": "labeler" inside data but it is changable on main frontend.
      const respData = await authApi.register(data);
      localStorage.setItem("access", respData.access);
      const userData = await authApi.getUser();
      dispatch(login(userData));
    } catch (e) {
      if (e?.response?.data?.non_field_errors.length)
        toast.info(e?.response?.data?.non_field_errors.join(","));
      else toast.info("Something went wrong. Please contact administrator.");
      dispatch(catchErrors(e, authError));
    }
  };

  useEffect(() => {
    if (isErrorsLength) {
      putFormValidationFocus();
    }
  }, [isErrorsLength]);

  return (
    <div className="register form__wrapper">
      <Form className="form" onSubmit={handleSubmit(onSubmit)}>
        <h1 className="form__title">Create a new account!</h1>
        <Row className="mb-2">
          <Col md="6">
            <HookInput
              label="Name"
              inputType="text"
              rules={{
                required: "Required field",
                maxLength: {
                  value: 150,
                  message: "Maximum menu length - 150 characters",
                },
                pattern: {
                  value: /^([а-яё]+|[a-z]+)$/i,
                  message: "The name can only contain letters",
                },
              }}
              name="first_name"
              control={control}
              errors={errors}
            />
          </Col>
          <Col md="6">
            <HookInput
              label="Surname"
              inputType="text"
              rules={{
                required: "Required field",
                maxLength: {
                  value: 150,
                  message: "Maximum menu length - 150 characters",
                },
                pattern: {
                  value: /^([а-яё]+|[a-z]+)$/i,
                  message: "The name can only contain letters",
                },
              }}
              name="last_name"
              control={control}
              errors={errors}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <HookInput
              label="Username"
              inputType="text"
              rules={{
                required: "Required field",
                maxLength: {
                  value: 150,
                  message: "Maximum menu length - 150 characters",
                },
                pattern: {
                  value: /^[\w.@+-]+$/,
                  message: "Only letters, numbers and symbols are allowed",
                },
              }}
              name="username"
              control={control}
              errors={errors}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <HookInput
              label="E-mail address"
              inputType="text"
              rules={{
                required: "Required field",
                maxLength: {
                  value: 254,
                  message: "Maximum menu length - 254 characters",
                },
                pattern: {
                  value: /.+@.+\..+/i,
                  message: "Enter a valid email address",
                },
              }}
              name="email"
              control={control}
              errors={errors}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col md="6">
            <HookInput
              label="Password"
              inputType="password"
              rules={{
                required: "Required field",
                minLength: {
                  value: 8,
                  message: "Minimum length is 8",
                },
                maxLength: {
                  value: 128,
                  message: "Maximum length - 128 characters",
                },
              }}
              name="password"
              control={control}
              errors={errors}
            />
          </Col>
          <Col md="6">
            <HookInput
              label="Password confirmation"
              inputType="password"
              rules={{
                required: "Required field",
                minLength: {
                  value: 8,
                  message: "Minimum length is 8",
                },
                maxLength: {
                  value: 128,
                  message: "Maximum menu length - 128 characters",
                },
                validate: (value) =>
                  value === watch("password") || "Enter the correct password",
              }}
              name="password_repeat"
              control={control}
              errors={errors}
            />
          </Col>
        </Row>

        <Button className="form__submit" type="submit" variant="danger">
          Registration
        </Button>

        {authError &&
          authError.status === 400 &&
          authError.url === "accounts/register/" && (
            <span className="form__validation-message">
              {authError.data.username}
            </span>
          )}

        <div className="form__bottom">
          <Link to={LOGIN}>
            <span className="form__link">Already have an account?</span>
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default memo(Register);
